// @ts-nocheck
import React from "react";
import { useNavigate } from "react-router-dom";
import "../styles/LegalPageLayout.css";

export function Divider() {
  return <div className="legal-divider" aria-hidden="true" />;
}

export function Section({ title, children }) {
  return (
    <section className="legal-section">
      <h2 className="legal-section-title">{title}</h2>
      {children}
    </section>
  );
}

export function BulletList({ items, children }) {
  if (items) {
    return (
      <ul className="legal-list">
        {items.map((item) => (
          <li key={item}>{item}</li>
        ))}
      </ul>
    );
  }

  return <ul className="legal-list">{children}</ul>;
}

export function InfoCallout({ variant = "info", title, children }) {
  return (
    <div className={`legal-callout legal-callout-${variant}`}>
      {title && <div className="legal-callout-title">{title}</div>}
      <div className="legal-callout-body">{children}</div>
    </div>
  );
}

export function PrimaryButton({ children, ...props }) {
  return (
    <button className="legal-btn legal-btn-primary" type="button" {...props}>
      {children}
    </button>
  );
}

export function SecondaryButton({ children, ...props }) {
  return (
    <button className="legal-btn legal-btn-secondary" type="button" {...props}>
      {children}
    </button>
  );
}

export function DangerButton({ children, ...props }) {
  return (
    <button className="legal-btn legal-btn-danger" type="button" {...props}>
      {children}
    </button>
  );
}

export default function LegalPageLayout({
  title,
  subtitle,
  updated,
  children,
  actions,
  backTo,
  backLabel = "Back"
}) {
  const navigate = useNavigate();
  const handleBack = () => {
    if (backTo) {
      navigate(backTo);
    } else {
      navigate(-1);
    }
  };

  return (
    <div className="legal-page-shell">
      <div className="legal-card">
        <div className="legal-title-row">
          <button className="legal-back" type="button" onClick={handleBack}>
            <span aria-hidden="true">←</span>
            <span>{backLabel}</span>
          </button>
          <div className="legal-title-stack">
            <h1 className="legal-title">{title}</h1>
            {subtitle && <p className="legal-subtitle">{subtitle}</p>}
            {updated && <p className="legal-updated">Last updated: {updated}</p>}
          </div>
        </div>

        <div className="legal-content">{children}</div>

        {actions && <div className="legal-actions">{actions}</div>}
      </div>
    </div>
  );
}
